import React from "react";
import PageContainer from "./PageContainer";

const App = () => <PageContainer />;

export default App;
